import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams, Platform } from "@ionic/angular";

@Component({
    selector: "app-modal-sos",
    templateUrl: "./modal-sos.component.html",
    styleUrls: ["./modal-sos.component.scss"],
    standalone: false
})
export class ModalSosComponent implements OnInit {
  user;

  constructor(
    private modalController: ModalController,
    public platform: Platform,
    private navParams: NavParams,
  ) {}

  ngOnInit() {}

  async ionViewDidEnter() {
    this.user = this.navParams.get("user");
  }

  close() {
    this.modalController.dismiss();
  }
}
